import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../core'
import * as space from '../../space'

export const RESOURCE = {
  payload: {
    description: 'Used to assess the space survey',
    dimension: space.RESOURCE.payload,
    name: 'Space Survey',
    partialId: PartialId.Standard.create('space_survey'),
  },
  type: core.quiver.Resource.Type.DmsSnapshot,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsSnapshot>

export const MODEL_ID = core.dms.models.Snapshot.Id.from({
  context: core.dms.models.Snapshot.Id.Context.from(RESOURCE.payload.dimension),
  partialId: RESOURCE.payload.partialId,
})
